import { HttpClient, HttpResponse } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import {
  ICountry,
  IPaginatedResponse,
  IOrganization,
  IOrganizationAdmin,
  IOrganizationContactPerson,
  IUser,
} from '@boma/administration-portal/shared/entities';
import { APP_CONFIG } from '@boma/app-config';

@Injectable({
  providedIn: 'root',
})
export class OrganizationService {
  private base: string;
  private version: string;
  constructor(
    @Inject(APP_CONFIG) private configuration: any,
    private httpClient: HttpClient
  ) {
    this.base = configuration.apiRoute;
    this.version = configuration.apiVersion;
  }

  listOrganizations(
    page: string = '1',
    query: string = '',
    perPage: string = '150'
  ) {
    return this.httpClient.get<IPaginatedResponse<IOrganization>>(
      `${this.base}api/v${this.version}/Entities`,
      {
        params: { page, perPage, query },
      }
    );
  }

  createOrganization(organization: IOrganization) {
    return this.httpClient.post<IOrganization>(
      `${this.base}api/v${this.version}/Entities`,
      {
        ...organization,
      }
    );
  }

  loadOrganizationDetails(organizationId: string) {
    return this.httpClient.get<IOrganization>(
      `${this.base}api/v${this.version}/Entities/${organizationId}`
    );
  }

  searchOrganizations(queryText: string) {
    return this.httpClient.get<IOrganization>(
      `${this.base}api/v${this.version}/Entities`,
      {
        params: { queryText },
      }
    );
  }

  loadOrganizationAdmins(organizationId: string) {
    return this.httpClient.get<IOrganizationAdmin[]>(
      `${this.base}api/v${this.version}/Entities/${organizationId}/Administrators`
    );
  }

  loadAdminUser(organizationId: string, userId: string) {
    return this.httpClient.get<IOrganizationAdmin>(
      `${this.base}api/v${this.version}/Entities/${organizationId}/Administrators/${userId}`
    );
  }

  updateOrganization(organization: IOrganization, organizationId: string) {
    return this.httpClient.put<IOrganization>(
      `${this.base}api/v${this.version}/Entities/${organizationId}`,
      {
        ...organization,
      }
    );
  }

  addContactPerson(
    contact: IOrganizationContactPerson,
    organizationId: string
  ) {
    return this.httpClient.post<IOrganization>(
      `${this.base}api/v${this.version}/Entities/${organizationId}/ContactPersons`,
      {
        ...contact,
      }
    );
  }

  uploadOrganizationImage(file) {
    let formData = new FormData();
    formData.append('file', file, file.name);
    return this.httpClient.post<string>(
      `${this.base}api/v${this.version}/Entities/UploadImage`,
      formData
    );
  }

  addRoleUser(userId: string, roleId: string, organizationId: string) {
    return this.httpClient.post<IUser>(
      `${this.base}api/v${this.version}/Entities/${organizationId}/Administrators/${userId}/${roleId}`,
      {}
    );
  }

  removeRoleUser(roleId: string, organizationId: string, userId: string) {
    return this.httpClient.delete<HttpResponse<any>>(
      `${this.base}api/v${this.version}/Entities/${organizationId}/Administrators/${userId}/${roleId}`
    );
  }

  removeContactPerson(contactId: string, organizationId: string) {
    return this.httpClient.delete<HttpResponse<any>>(
      `${this.base}api/v${this.version}/Entities/${organizationId}/ContactPersons/${contactId}`
    );
  }

  getCountries() {
    return this.httpClient.get<ICountry[]>(
      `${this.base}api/v${this.version}/Countries`
    );
  }
}
